/**
 * Created by zhayuechao on 2018/06/14
 */

//客户搜索时间颗粒度所有时间颗粒度
const VIP_HEADER_TIME_LINE_ALL = {
  day: {
    dictLabel: "按日",
    dictValue: "1",
    byWhichWay: "byDay"
  },
  week: {
    dictLabel: "按周",
    dictValue: "2",
    byWhichWay: "byWeek"
  },
  month: {
    dictLabel: "按月",
    dictValue: "3",
    byWhichWay: "byMonth"
  },
  season: {
    dictLabel: "按季度",
    dictValue: "4",
    byWhichWay: "bySeason"
  },
  year: {
    dictLabel: "按年",
    dictValue: "5",
    byWhichWay: "byYear"
  },
}

// 所有日期
const TAB_ALLDATE = [
  {
    tabNumber: 1,
    tabDateName: "昨日"
  },
  {
    tabNumber: 2,
    tabDateName: "本周"
  },
  {
    tabNumber: 3,
    tabDateName: "上周"
  },
  {
    tabNumber: 4,
    tabDateName: "本月"
  },
  {
    tabNumber: 5,
    tabDateName: "上月"
  }
];
// 天数日期
const TAB_DAY = [
  {
    tabId: 1,
    tabDayName: "最近7天"
  },
  {
    tabId: 2,
    tabDayName: "最近30天"
  },
  {
    tabId: 3,
    tabDayName: "最近90天"
  }
];

// 报表----aside
const ASIDE_TITLE = [
  {
    title: "概况",
    titleIndex: "1",
    activeName: "1",
    icon: "icon-personalvideo"
  },
  {
    title: "目标分析",
    titleIndex: "2",
    icon: "icon-icon_gongzuo_mubiaox",
    levelInfo: [
      {
        level: "目标概况",
        levelIndex: "target_survey",
        path: { name: "target_survey" }
      },
      {
        level: "目标分析",
        levelIndex: "target_analysis",
        path: { name: "target_analysis" }
      }
      // {
      //   level: '目标管理',
      //   levelIndex: 'target_manager',
      //   path: {name: 'target_manager'}
      // }
    ]
  },
  {
    title: "销售分析",
    titleIndex: "3",
    icon: "icon-equalizer",
    levelInfo: [
      {
        level: "销售概况",
        levelIndex: "operate_survey",
        path: { name: "operate_survey" }
      },
      {
        level: "销售趋势",
        levelIndex: "operate_trend",
        path: { name: "operate_trend" }
      },
      {
        level: "销售增长",
        levelIndex: "operate_target_trend",
        path: { name: "operate_target_trend" }
      },
      {
        level: "客流分析",
        levelIndex: "operate_passenger",
        path: { name: "operate_passenger" }
      },
      {
        level: "客单价",
        levelIndex: "operate_price",
        path: { name: "operate_price" }
      },
      {
        level: "预约分析",
        levelIndex: "operate_appoint",
        path: { name: "operate_appoint" }
      },
      {
        level: "项目分析",
        levelIndex: "operate_project_analysis",
        path: { name: "operate_project_analysis" }
      },
      {
        level: "门店对比",
        levelIndex: "operate_store",
        path: { name: "operate_store" }
      },
      {
        level: "单店趋势",
        levelIndex: "single_trend",
        path: { name: "single_trend" }
      },
      // {
      //   level: '办卡分析',
      //   levelIndex: 'operate_card',
      //   path: {name: 'operate_card'}
      // }
    ]
  },
  // 开卡分析
  {
    title: "开卡分析",
    titleIndex: "4",
    icon: "icon-payment",
    levelInfo: [
      {
        level: "开卡概况",
        levelIndex: "card_survey",
        path: { name: "card_survey" }
      },
      {
        level: "开卡趋势",
        levelIndex: "card_trend",
        path: { name: "card_trend" }
      },
      {
        level: "开卡增长",
        levelIndex: "card_target_trend",
        path: { name: "card_target_trend" }
      },
      {
        level: "卡对比",
        levelIndex: "card_contrast",
        path: { name: "card_contrast" }
      },
      {
        level: "充值分析",
        levelIndex: "card_price",
        path: { name: "card_price" }
      },
      {
        level: "渠道来源分析",
        levelIndex: "card_customer",
        path: { name: "card_customer" }
      },
      {
        level: "门店对比",
        levelIndex: "card_store",
        path: { name: "card_store" }
      }
    ]
  },
  // 运营分析
  {
    title: "运营分析",
    titleIndex: "5",
    icon: "icon-yunyingfenxi",
    levelInfo: [
      {
        level: "运营概况",
        levelIndex: "run_survey",
        path: { name: "run_survey" }
      },
      {
        level: "运营趋势",
        levelIndex: "run_trend",
        path: { name: "run_trend" }
      },
      {
        level: "运营增长",
        levelIndex: "run_target",
        path: { name: "run_target" }
      },
      {
        level: "服务质量分析",
        levelIndex: "run_server",
        path: { name: "run_server" }
      },
      {
        level: "NPS分析",
        levelIndex: "run_NPS",
        path: { name: "run_NPS" }
      },
      {
        level: "点钟分析",
        levelIndex: "run_clock",
        path: { name: "run_clock" }
      },
      {
        level: "打赏分析",
        levelIndex: "run_reward",
        path: { name: "run_reward" }
      },
      {
        level: "按摩需求分析",
        levelIndex: "run_need",
        path: { name: "run_need" }
      },
      {
        level: "门店对比",
        levelIndex: "run_store",
        path: { name: "run_store" }
      }
      // {
      //   level: '房间使用率',
      //   levelIndex: 'room_rate',
      //   path: {name: 'room_rate'}
      // }
    ]
  }
  // {
  //   title: '市场营销',
  //   titleIndex: '4',
  //   icon: 'icon-time-lapse',
  //   levelInfo: [{
  //     level: '活动/优惠券趋势',
  //     levelIndex: 'market_trend',
  //     path: {name: 'market_trend'}
  //   },
  //   {
  //     level: '活动/优惠券分布',
  //     levelIndex: 'market_distribute',
  //     path: {name: 'market_distribute'}
  //   },
  //   {
  //     level: '积分兑换',
  //     levelIndex: 'market_integral',
  //     path: {name: 'market_integral'}
  //   }]
  // },
];
// 市场报表
const MARKET = [
  {
    title: "会员分析",
    titleIndex: "1",
    icon: "icon-ion-person-add",
    levelInfo: [
      {
        level: "会员概况",
        levelIndex: "cust_index",
        path: { name: "cust_index" }
      },
      {
        level: "会员趋势",
        levelIndex: "cust_target_trend",
        path: { name: "cust_target_trend" }
      },
      {
        level: "会员增长",
        levelIndex: "cust_target",
        path: { name: "cust_target" }
      },
      {
        level: "留存分析",
        levelIndex: "cust_save",
        path: { name: "cust_save" }
      },
      {
        level: "忠诚度",
        levelIndex: "cust_faith",
        path: { name: "cust_faith" }
      },
      {
        level: "新会员来源分析",
        levelIndex: "cust_newMembers",
        path: { name: "cust_newMembers" }
      },
      {
        level: "会员分析",
        levelIndex: "cust_Members",
        path: { name: "cust_Members" }
      }
    ]
  },
  {
    title: "活动分析",
    titleIndex: "2",
    icon: "icon-huodong",
    levelInfo: [
      {
        level: "活动概况",
        levelIndex: "activity_index",
        path: { name: "activity_index" }
      },
      {
        level: "活动趋势",
        levelIndex: "activity_target_trend",
        path: { name: "activity_target_trend" }
      },
      {
        level: "活动详情",
        levelIndex: "activity_detail",
        path: { name: "activity_detail" }
      },
      {
        level: "漏斗转化",
        levelIndex: "activity_change",
        path: { name: "activity_change" }
      },
      {
        level: "留存分析",
        levelIndex: "activity_save",
        path: { name: "activity_save" }
      }
    ]
  },
  {
    title: "优惠券分析",
    titleIndex: "3",
    icon: "icon-youhuiquan",
    levelInfo: [
      {
        level: "优惠券概况",
        levelIndex: "coupons_index",
        path: { name: "coupons_index" }
      },
      {
        level: "优惠券趋势",
        levelIndex: "coupons_target_trend",
        path: { name: "coupons_target_trend" }
      },
      {
        level: "优惠券详情",
        levelIndex: "coupons_detail",
        path: { name: "coupons_detail" }
      },
      {
        level: "漏斗转化",
        levelIndex: "coupons_change",
        path: { name: "coupons_change" }
      },
      {
        level: "留存分析",
        levelIndex: "coupons_save",
        path: { name: "coupons_save" }
      }
    ]
  },
  {
    title: "积分分析",
    titleIndex: "4",
    icon: "icon-jifen",
    levelInfo: [
      {
        level: "积分兑换概况",
        levelIndex: "integral_index",
        path: { name: "integral_index" }
      },
      {
        level: "积分趋势",
        levelIndex: "integral_target_trend",
        path: { name: "integral_target_trend" }
      },
      {
        level: "积分分析",
        levelIndex: "integral_analysis",
        path: { name: "integral_analysis" }
      },
      {
        level: "兑换商品分析",
        levelIndex: "integral_goods",
        path: { name: "integral_goods" }
      }
    ]
  }
];
// 绩效
const PERFORMANCE = [
  {
    title: "效率分析",
    titleIndex: "1",
    icon: "icon-chengbenjianshaoxiaoshuaitigao",
    levelInfo: [
      {
        level: "效率概况",
        levelIndex: "eff_survey",
        path: { name: "eff_survey" }
      },
      {
        level: "效率趋势",
        levelIndex: "eff_trend",
        path: { name: "eff_trend" }
      },
      {
        level: "效率增长",
        levelIndex: "eff_target",
        path: { name: "eff_target" }
      },
      {
        level: "效率分析",
        levelIndex: "eff_therapist",
        path: { name: "eff_therapist" }
      },
      {
        level: "门店对比",
        levelIndex: "eff_store",
        path: { name: "eff_store" }
      }
    ]
  },
  {
    title: "理疗师绩效",
    titleIndex: "2",
    icon: "icon-donut-large",
    levelInfo: [
      {
        level: "理疗师概况",
        levelIndex: "perform_survey",
        path: { name: "perform_survey" }
      },
      {
        level: "理疗师详情",
        levelIndex: "perform_analyze",
        path: { name: "perform_analyze" }
      },
      // {
      //   level: '理疗师趋势',
      //   levelIndex: 'perform_trend',
      //   path: {name: 'perform_trend'}
      // },
      {
        level: "理疗师增长",
        levelIndex: "perform_target_trend",
        path: { name: "perform_target_trend" }
      },
      {
        level: "理疗师对比",
        levelIndex: "perform_contrast",
        path: { name: "perform_contrast" }
      }
    ]
  }
];

// 数据查询
const DATA_QUERY = [
  {
    title: "数据查询",
    titleIndex: "1",
    icon: "icon-ion-person-add",
    levelInfo: [
      {
        level: "评价管理",
        levelIndex: "store-evalute",
        path: { name: "store-evalute" }
      },
      {
        level: "NPS管理",
        levelIndex: "store_nps",
        path: { name: "store_nps" }
      },
      {
        level: "打赏管理",
        levelIndex: "store_reward",
        path: { name: "store_reward" }
      },
      {
        level: "服务小计",
        levelIndex: "store_service",
        path: { name: "store_service" }
      },
      {
        level: "目标管理",
        levelIndex: "target_manage",
        path: { name: "target_manage" }
      },
      {
        level: "未续充会员",
        levelIndex: "nofill_Members",
        path: { name: "nofill_Members" }
      }
      // {
      //   level: '积分管理',
      //   levelIndex: 'perform_target_trend',
      //   path: {name: 'perform_target_trend'}
      // }
    ]
  }
];

const DATA_ENTRY = [
  {
    title: "数据导入",
    titleIndex: "1",
    icon: "icon-ion-person-add",
    levelInfo: [
      {
        level: "excel",
        levelIndex: "data",
        path: { name: "data" }
      }
    ]
  }
];

const clearCompare = {
  compareStoreID: null,
  compareCustType: null,
  compareIsOld: null,
  compareStartTime: null,
  compareEndTime: null,
  compareEmpID: null,
  comStoreName: null,
  comCustTypeName: null,
  comIsOldName: null,
  comBookSourceName: null,
  comMiniPrice: null,
  comMaxPrice: null,
  comPriceName: null,
  compareCategoryID: null,
  compareProdID: null,
  comCategoryName: null,
  comProdName: null
};

const clearTableQuery = {
  pageSize: 20,
  pageNum: 1
};

const chartPointTitle = {
  1: "时间",
  2: "门店",
  3: "顾客",
  4: "项目",
  5: "理疗师"
};

// 高级分析
const ANALYZE = [
  {
    title: "高级分析",
    activeName: "3",
    titleIndex: "1",
    icon: "icon-equalizer"
  }
];

// const TIMEHOUR = ['11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30']
// const TIMEHOUR = ['11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00']
const TIMEHOUR = [
  "23:00",
  "22:00",
  "21:00",
  "20:00",
  "19:00",
  "18:00",
  "17:00",
  "16:00",
  "15:00",
  "14:00",
  "13:00",
  "12:00",
  "11:00",
  "10:00"
];

const STARS = [
  { value: 0, label: "全部" },
  { value: 5, label: "5星" },
  { value: 4, label: "4星" },
  { value: 3, label: "3星" },
  { value: 2, label: "2星" },
  { value: 1, label: "1星" }
];

const NPSSTARS = [
  { value: -1, label: "全部" },
  { value: 10, label: "10星" },
  { value: 9, label: "9星" },
  { value: 8, label: "8星" },
  { value: 7, label: "7星" },
  { value: 6, label: "6星" },
  { value: 5, label: "5星" },
  { value: 4, label: "4星" },
  { value: 3, label: "3星" },
  { value: 2, label: "2星" },
  { value: 1, label: "1星" },
  { value: 0, label: "0星" }
];

const REWARDCHANNEL = [
  { value: 0, label: "全部" },
  { value: 1, label: "门店微信" },
  { value: 2, label: "二维码-小程序" }
];

const QUERY_TABLE = {
  staff: {
    title: [
      "日期",
      "顾客姓名",
      "门店",
      "理疗师",
      "服务星级",
      "手法星级",
      "评价",
      "渠道",
      "填写姓名",
      "手机号"
    ]
  },
  'order-evaluation': {
    title: [
      "日期",
      "顾客姓名",
      "门店",
      "评分",
      "标签",
      "评价",
      "推荐门店意愿",
      "手机号",
    //   "操作",
    ]
  },
  nps: {
    title: ["日期", "顾客姓名", "门店", "NPS评分", "评价"]
  },
  service: {
    title: [
      "创建时间",
      "订单号",
      "顾客姓名",
      "身体疲劳点",
      "力度偏好",
      "特殊状况",
      "避免按摩",
      "客户关怀",
      "服务技师"
    ]
  },
  reward: {
    title: ["日期", "顾客姓名", "金额", "门店", "技师", "渠道", "是否点评"]
  },
  nofill: {
    title: [
      "日期",
      "顾客姓名",
      "手机号码",
      "门店",
      "卡类型",
      "卡名称",
      "订单号",
      "消费金额"
    ]
  }
};

const MemberClass = [
  // {label: '全部', customerType: -1},
  // {label: '储值会员', customerType: 1},
  // {label: '非储值会员', customerType: 2},
  { label: "全部", value: -1 },
  { label: "储值会员", value: 1 },
  { label: "非储值会员", value: 2 },
  { label: "其他", value: 4 }
  // {label: '其他', value: 9, children: [{label: '共建人', value: 3}, {label: '员工', value: 4}, {label: '招待卡', value: 5}, {label: '全部', value: 6}]}
];

const CustomerClass = [
  { label: "全部", isOld: -1 },
  { label: "新客", isOld: 0 },
  { label: "老客", isOld: 1 },
  { label: "散客", isOld: 2 }
];

const CustomerClassTwo = [
  { label: "全部", isOld: -1 },
  { label: "新客", isOld: 0 },
  { label: "老客", isOld: 1 }
];
const CustomerClassThree = [
  { label: "全部", isOld: -1 },
  { label: "新客", isOld: 0 },
  { label: "老客", isOld: 1 },
  { label: "潜客", isOld: 3 }
];

const CardType = [
  { label: "全部", cardType: -1 },
  { label: "1-1000", cardType: 0 },
  { label: "1001-4999", cardType: 1 },
  { label: "5000-9999", cardType: 2 },
  { label: "10000及以上", cardType: 3 }
];
const sourceAppoint = [
  { label: "全部", value: -1 },
  { label: "微信预约", value: 2 },
  { label: "电话预约", value: 0 },
  { label: "点评预约", value: 4 }
];

const passFlow = [
  { label: "全部", value: -1 },
  {
    label: "预约",
    value: 1,
    children: [
      { label: "全部", value: 1 },
      { label: "微信预约", value: 2 },
      { label: "电话预约", value: 0 },
      { label: "点评预约", value: 4 }
    ]
  },
  { label: "直接到店", value: 3 }
];

const cardTypeList = [
  { value: -1, label: "全部" },
  {
    value: 1000,
    label: "次卡",
    children: [
      { value: 1000, label: "全部" },
      { value: 2001, label: "总次卡" },
      { value: 2002, label: "分次卡" }
    ]
  },
  { value: 1001, label: "储值卡", }
];




const comeChannel = [
  { label: "全部", value: -1 },
  { label: "大众点评", value: 2 },
  { label: "小红书", value: 0 },
  { label: "点评预约", value: 4 }
];
const couponList = [
  { label: "全部", value: -1 },
  { label: "折扣券", value: 4 },
  { label: "项目券", value: 5 },
  { label: "现金券", value: 6 }
];
const activityTypeList = [
  { label: "全部", value: -1 },
  { label: "渠道活动", value: 0 },
  { label: "团购活动", value: 1 },
  { label: "买赠活动", value: 2 },
  { label: "自定义活动", value: 3 }
];
const goodsStatusList = [
  { label: "全部", value: -1 },
  { label: "有效", value: 1 },
  { label: "失效", value: 0 }
];
const targetList = [
  {
    label: "销售",
    value: 0,
    children: [
      { label: "理疗师工作人天", value: 9 },
      { label: "实际收入", value: 6 },
      { label: "开卡收入", value: 7 },
      { label: "现金流", value: 8 }
    ]
  },
  {
    label: "客流",
    value: 1,
    children: [
      { label: "订单课次", value: 3 },
      { label: "新客课次", value: 4 },
      { label: "非储值老客客次", value: 5 },
      { label: "储值会员客次", value: 6 }
    ]
  },
  {
    label: "客单价",
    value: 2,
    children: [
      { label: "客单价(折扣前)", value: 3 },
      { label: "客单价(折扣后)", value: 4 },
      { label: "新客客单价(折扣后)", value: 5 },
      { label: "非储值老客客单价(折扣后)", value: 6 },
      { label: "储值会员客单价(折扣后)", value: 6 }
    ]
  },
  {
    label: "服务",
    value: 3,
    children: [
      { label: "留存率", value: 3 },
      { label: "差评率", value: 4 },
      { label: "打赏率", value: 5 },
      { label: "新客微信关注率", value: 6 }
    ]
  },
  {
    label: "储值转化",
    value: 4,
    children: [
      { label: "储值会员转化率", value: 3 },
      { label: "新客储值会员转化率", value: 4 },
      { label: "老客储值会员转化率", value: 5 },
      { label: "客均储值", value: 6 }
    ]
  }
];
export {
  VIP_HEADER_TIME_LINE_ALL,
  // 对比字段
  clearCompare,
  clearTableQuery,
  TAB_ALLDATE,
  TAB_DAY,
  ASIDE_TITLE,
  DATA_QUERY,
  DATA_ENTRY,
  ANALYZE,
  chartPointTitle,
  TIMEHOUR,
  STARS,
  NPSSTARS,
  REWARDCHANNEL,
  QUERY_TABLE,
  MemberClass,
  CustomerClass,
  CardType,
  targetList,
  passFlow,
  cardTypeList,
  sourceAppoint,
  PERFORMANCE,
  MARKET,
  comeChannel,
  CustomerClassTwo,
  CustomerClassThree,
  couponList,
  activityTypeList,
  goodsStatusList
};
